import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { validatelogin } from '../../../validation/login';
import { userLogin } from '../../../redux/actions/loginaction';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [fields, setFields] = useState();

  const [fielderror, setFieldError] = useState({});
  const [issubmit, setIssubmit] = useState(false);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const keyName = e.target.name;
    const keyValue = e.target.value;
    setFields((prevState) => ({
      ...prevState,
      [keyName]: keyValue,
    }));
    if (issubmit) {
      setFieldError(validatelogin({ ...fields, [keyName]: keyValue }));
    }
  };

  const handleClick = () => {
    setIssubmit(true);
    const obj = {
      EmployeeEmailId: fields?.email,
      Password: fields?.password,
    };
    const error = validatelogin(fields);
    console.log('error', error);

    if (Object.keys(error).length === 0) {
      dispatch(userLogin(obj, navigate)).then((res) => {
        if (res.status === 200) {
          toast.success('Login successfully');
        } else {
          toast.error(res.message, { autoClose: 1500 });
        }
      });
    } else {
      console.log('Error:', error);
    }
    setFieldError(validatelogin(fields));
  };

  // const handleSend = () => {
  //   const obj = {
  //     EmployeeEmailId: fields?.email,
  //     password: fields?.password,
  //   };
  //   setIssubmit(true);
  //   const error = validatelogin(fields);
  //     dispatch(sendOtp(obj)).then((res) => {
  //   if (Object.keys(error).length === 0) {
  //       if (res?.status === 200) {
  //         setOtpField('');
  //       }
  //     });
  //   } else {
  //     console.log('Error:', error);
  //   }
  //   setFieldError(validatelogin(fields));
  // };

  return (
    <>
      <Stack spacing={3}>
        <TextField type="email" name="email" onChange={handleChange} label="Email" />
        <div style={{ marginTop: '2px', color: 'red' }}>{fielderror.EmployeeEmailId}</div>

        <TextField
          style={{ marginTop: '6px' }}
          name="password"
          label="Password"
          onChange={handleChange}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <div style={{ marginTop: '2px', color: 'red' }}>{fielderror.password}</div>
      </Stack>

      {/* <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <Checkbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
        Forgot password?
        </Link>
      </Stack> */}

      <>
        {/* <Link sx={{ marginTop: '2px', textAlign: 'end' }} variant="subtitle2" underline="hover" onClick={handleSend}>
          Resend Otp
        </Link> */}
        <LoadingButton
          fullWidth
          size="large"
          sx={{ marginTop: '10px' }}
          type="submit"
          variant="contained"
          onClick={handleClick}
        >
          Login
        </LoadingButton>
      </>
    </>
  );
}
